
const espressoEquipment = [
    {
        "name": "Lelit Bianca v3 (Chrome)",
        "link": "https://www.1st-line.com/buy/lelit-bianca-v3-espresso-machine/",
        "price": "$2,999.00",
        "image": "/assets/espresso/LelitBianca.jpg"
    },
    {
        "name": "DF64 Grinder Gen 2 (Used, from FB Marketplace)",
        "link": "https://df64coffee.com/products/df64-gen-2-single-dose-coffee-grinder",
        "price": "$280.00",
        "image": "/assets/espresso/900_900_crop.jpg"
    },
    {
        "name": "Stainless Steel Coffee Knock Box Drawer Thickened Residue Powder Holder for",
        "link": "https://www.ebay.com/itm/235892727385",
        "price": "$24.06",
        "image": "/assets/espresso/knock-boxs-l1600.webp"
    },
    {
    "name": "ESPRESSO FILTER BASKET 18g 58mm for LA MARZOCCO/FUTURMAT/DEC",
    "link": "https://www.amazon.com/dp/B0DFRB2QRG?ref=ppx_yo2ov_dt_b_fed_asin_title&th=1",
    "price": "$9\n.99",
    "image": "/assets/espresso/espresso_filter_basket_18g_58mm_for_la_marzocco_futurmat_dec.jpg"
  },
  {
    "name": "Aieve WDT Tool Espresso, Distribution Tool Espresso Machine Accessories(Ease of Use in 2 Ways Installtion)",
    "link": "https://www.amazon.com/dp/B0BGKXQ2B4?ref=ppx_yo2ov_dt_b_fed_asin_title&th=1",
    "price": "$8\n.99",
    "image": "/assets/espresso/aieve_wdt_tool_espresso__distribution_tool_espresso_machine_accessories_ease_of_use_in_2_ways_installtion_.jpg"
  },
  {
    "name": "2 Pack 58.5mm Espresso Puck Screen, Reusable 1.7mm Thickness 150μm Coffee Filter Mesh Plate for Espresso Portafilter Filter Basket (58.5mm,150μm)",
    "link": "https://www.amazon.com/dp/B09XLL2PPB?ref=ppx_yo2ov_dt_b_fed_asin_title&th=1",
    "price": "$6\n.99",
    "image": "/assets/espresso/2_pack_58_5mm_espresso_puck_screen__reusable_1_7mm_thickness_150_m_coffee_filter_mesh_plate_for_espresso_portafilter_filter_basket__58_5mm_150_m_.jpg"
  },
  {
    "name": "BAGAIL BASICS Coffee Scale with Timer, 0.1g High Precision Kitchen Scale, Pour Over Coffee Scale, Drip Espresso Scale with Auto Tare, Touch Sensor and Silicone Cover - 6.6 lbs/3 kg",
    "link": "https://www.amazon.com/dp/B0BNL5JCVR?ref=ppx_yo2ov_dt_b_fed_asin_title",
    "price": "$19\n.99",
    "image": "/assets/espresso/bagail_basics_coffee_scale_with_timer__0_1g_high_precision_kitchen_scale__pour_over_coffee_scale__drip_espresso_scale_with_auto_tare__touch_sensor_and_silicone_cover___6_6_lbs_3_kg.jpg"
  },
  {
    "name": "Set of Two Libbey Duratuff Cortado Glasses | Gibraltar Rocks Glass 4.5 OZ ~Paper Coasters Included~",
    "link": "https://www.amazon.com/dp/B078JFYZSS?ref=ppx_yo2ov_dt_b_fed_asin_title",
    "price": "$14\n.00",
    "image": "/assets/espresso/set_of_two_libbey_duratuff_cortado_glasses___gibraltar_rocks_glass_4_5_oz__paper_coasters_included_.jpg"
  },
  {
    "name": "AMOAMI-Coffee Mat Hide Stain Rubber Backed Absorbent Dish Drying Mat for Kitchen Counter-Coffee Bar Accessories Fit Under Coffee Maker Coffee Machine Coffee Pot Espresso Machine 12\"x19\" Dark Grey",
    "link": "https://www.amazon.com/dp/B09SYNZ1LY?ref=ppx_yo2ov_dt_b_fed_asin_title&th=1",
    "price": "$7\n.40",
    "image": "/assets/espresso/amoami_coffee_mat_hide_stain_rubber_backed_absorbent_dish_drying_mat_for_kitchen_counter_coffee_bar_accessories_fit_under_coffee_maker_coffee_machine_coffee_pot_espresso_machine_12_x19__dark_grey.jpg"
  },
  {
    "name": "Coffee Machine Descaler - 2 Uses - Descaling Solution for Nespresso Breville Keurig Jura & More - USA Made Cleaner For All Coffee Machines, Glass Pot Cleaner and Espresso Makers",
    "link": "https://www.amazon.com/dp/B01CM0TR5Y?ref=ppx_yo2ov_dt_b_fed_asin_title&th=1",
    "price": "$8\n.85",
    "image": "/assets/espresso/coffee_machine_descaler___2_uses___descaling_solution_for_nespresso_breville_keurig_jura___more___usa_made_cleaner_for_all_coffee_machines__glass_pot_cleaner_and_espresso_makers.jpg"
  },
  {
    "name": "Espresso Machine Cleaning Brush Kit - CAFEMASY 2 Pieces Coffee Cleaning Brush with Spoon and 2 Pieces Detachable Brush Head for Coffee Grinder and Espresso Cleaning",
    "link": "https://www.amazon.com/dp/B088R41MLH?ref=ppx_yo2ov_dt_b_fed_asin_title&th=1",
    "price": "$9\n.99",
    "image": "/assets/espresso/espresso_machine_cleaning_brush_kit___cafemasy_2_pieces_coffee_cleaning_brush_with_spoon_and_2_pieces_detachable_brush_head_for_coffee_grinder_and_espresso_cleaning.jpg"
  },
  {
    "name": "Aluminum Espresso Dosing Funnel, Dosing Ring Suitable for 58mm Portafilters in Black Color",
    "link": "https://www.amazon.com/dp/B089R7NTXM?ref=ppx_yo2ov_dt_b_fed_asin_title",
    "price": "$5\n.99",
    "image": "/assets/espresso/aluminum_espresso_dosing_funnel__dosing_ring_suitable_for_58mm_portafilters_in_black_color.jpg"
  },
  {
    "name": "Lisapack 8ML Atomizer Perfume Spray Bottle for Travel, Empty Refillable Cologne Dispenser, Portable Sprayer (Matte Black)",
    "link": "https://www.amazon.com/dp/B0799CCY2Y?ref=ppx_yo2ov_dt_b_fed_asin_title&th=1",
    "price": "$6\n.99",
    "image": "/assets/espresso/lisapack_8ml_atomizer_perfume_spray_bottle_for_travel__empty_refillable_cologne_dispenser__portable_sprayer__matte_black_.jpg"
  },
  {
    "name": "Homaxy 100% Cotton Waffle Weave Kitchen Dish Cloths, Ultra Soft Absorbent Quick Drying Dish Towels, 12 x 12 Inches, 6-Pack, Dark Grey",
    "link": "https://www.amazon.com/dp/B07WMQP4SF?ref=ppx_yo2ov_dt_b_fed_asin_title&th=1",
    "price": "$9\n.98",
    "image": "/assets/espresso/homaxy_100__cotton_waffle_weave_kitchen_dish_cloths__ultra_soft_absorbent_quick_drying_dish_towels__12_x_12_inches__6_pack__dark_grey.jpg"
  },
  {
    "name": "Apexstone 58mm Coffee Distributor, Coffee Distributor 58mm, Coffee Distribution Tool 58mm, Coffee Distributor Tool 58mm, Coffee Leveler 58mm",
    "link": "https://www.amazon.com/dp/B077BZ4CV6?ref=ppx_yo2ov_dt_b_fed_asin_title&th=1",
    "price": "$17\n.99",
    "image": "/assets/espresso/apexstone_58mm_coffee_distributor__coffee_distributor_58mm__coffee_distribution_tool_58mm__coffee_distributor_tool_58mm__coffee_leveler_58mm.jpg"
  },
  {
    "name": "58mm Espresso Tamper, Coffee Tamper for Espresso Machine, Espresso Tamp with Spring Loaded Tamper, Depth-adjustable Espresso Hand Tampers 58mm",
    "link": "https://www.amazon.com/dp/B0CLV6MH29?ref=ppx_yo2ov_dt_b_fed_asin_title&th=1",
    "price": "$16\n.97",
    "image": "/assets/espresso/58mm_espresso_tamper__coffee_tamper_for_espresso_machine__espresso_tamp_with_spring_loaded_tamper__depth_adjustable_espresso_hand_tampers_58mm.jpg"
  },
  // {
  //   "name": "homEdge Mini Procelain Espresso Cup, 3 Ounces / 90 ml Tiny Coffee Mugs Demitasse for Espresso, Tea- Set of 6, Light Gray",
  //   "link": "https://www.amazon.com/dp/B0B3MDLDP7?ref=ppx_yo2ov_dt_b_fed_asin_title&th=1",
  //   "price": "$17\n.99",
  //   "image": "/assets/espresso/homedge_mini_procelain_espresso_cup__3_ounces___90_ml_tiny_coffee_mugs_demitasse_for_espresso__tea__set_of_6__light_gray.jpg"
  // },
  {
    "name": "Coffee Dosing Cup 58mm, Stainless Steel Espresso Dosing Cup Compatible with All 58mm Portafilter, Coffee Grinder Powder Cup, Coffee Powder Feeder, Espresso Coffee Machine Accessories",
    "link": "https://www.amazon.com/dp/B0DKFXWKR8?ref=ppx_yo2ov_dt_b_fed_asin_title",
    "price": "$8\n.99",
    "image": "/assets/espresso/coffee_dosing_cup_58mm__stainless_steel_espresso_dosing_cup_compatible_with_all_58mm_portafilter__coffee_grinder_powder_cup__coffee_powder_feeder__espresso_coffee_machine_accessories.jpg"
  }
];

const totalPrice = espressoEquipment.reduce((sum, item) => {
    return sum + parseFloat(item.price.replace('$', ''));
}, 0).toFixed(2);

export { espressoEquipment, totalPrice };
